export default {
  TourGuide: {
    PreviousStep: 'Quay lại',
    NextStep: 'Tiếp tục',
    FinishStep: 'Đã hiểu'
  }
}
